import React from 'react';
import { TopProduct } from '../../types/dashboard';
import { Trophy } from 'lucide-react';

interface TopProductsTableProps {
  products: TopProduct[];
}

export const TopProductsTable: React.FC<TopProductsTableProps> = ({ products }) => {
  const formatCurrency = (value: number): string => {
    return `${value.toLocaleString('hu-HU')} Ft`;
  };

  const getRankIcon = (rank: number) => {
    const colors = [
      'text-yellow-500', // 1st place - gold
      'text-gray-400', // 2nd place - silver
      'text-amber-600', // 3rd place - bronze
      'text-gray-500', // 4th place
      'text-gray-500', // 5th place
    ];
    return colors[rank - 1] || 'text-gray-500';
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700">
      <div className="flex items-center gap-2 mb-4">
        <Trophy className="w-5 h-5 text-yellow-500" />
        <h3 className="text-lg font-semibold text-slate-800 dark:text-gray-200">Top Termékek</h3>
      </div>

      {products.length === 0 ? (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
          <p>Nincs elérhető adat</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 dark:border-gray-700">
                <th className="text-left py-3 px-4 text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                  Helyezés
                </th>
                <th className="text-left py-3 px-4 text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                  Termék
                </th>
                <th className="text-right py-3 px-4 text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                  Mennyiség
                </th>
                <th className="text-right py-3 px-4 text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                  Bevétel
                </th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                >
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      <Trophy className={`w-4 h-4 ${getRankIcon(index + 1)}`} />
                      <span className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                        #{index + 1}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <span className="text-sm text-gray-800 dark:text-gray-200 font-medium">
                      {product.product_name}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className="text-sm text-gray-700 dark:text-gray-300">
                      {product.total_quantity.toLocaleString('hu-HU')} db
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className="text-sm font-semibold text-green-600 dark:text-green-400">
                      {formatCurrency(product.total_revenue)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
